import { Component, ElementRef, inject, OnInit, ViewChild, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SopraServiceTableData } from '../../models/sopra-services';
import { SopraConfigurationsService } from '../../services/sopra-configurations/sopra-configurations.service';
import { FiltersService } from 'src/app/core/services/filters/filters.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterUtilService } from 'src/app/core/services/uitls/filter-utilizer/filter-util.service';
import { handlePaginationChangeUtil } from 'src/app/core/services/uitls/navigation.utils';

@Component({
    selector: 'app-sopra-services',
    templateUrl: './sopra-services.component.html',
    styleUrl: './sopra-services.component.scss',
    standalone: false
})
export class SopraServicesComponent implements OnInit {

  sopraServices: SopraServiceTableData[] = [];
  filterData!: any;
  filterDataInit = {};
  spinner: boolean = false;
  spinnerKey: string = 'spinner';
  page_size: number = 20;
  page: number = 1;
  totalRecords: number = 0;
  searchValue: string = '';
  filterParamsUrl = {};
  filterPage: string = 'SERVICE_CLASSIFICATIONS';

  config = {
    id: 'myPagination',
    itemsPerPage: this.page_size,
    currentPage: this.page,
    totalItems: this.totalRecords,
  };
  
  @ViewChild('goUp', { static: true }) contentPage!: ElementRef;
  
  private destroyRef = inject(DestroyRef);
  private sopraConfigurationsService = inject(SopraConfigurationsService);
  filter = inject(FiltersService);
  route = inject(ActivatedRoute);
  router = inject(Router);
  filterUtil = inject(FilterUtilService);

  ngOnInit(): void {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params: any) => {
      if (params.page && params.page_size) {
        this.page = Number(params.page)
        this.page_size = Number(params.page_size);
        this.config.currentPage = Number(params.page);
        this.config.itemsPerPage = Number(params.page_size);
      } else {
        this.router.navigate([], {
          queryParams: { page: 1, page_size: 20 },
          queryParamsHandling: 'merge',
        });
      }
      this.setFilterParamsValues(params);
    });

    this.getSopraServiceFilter();
    this.filterUtil.getSavedFilters(this, this.filterPage);
    this.filter.changeSelectedFilter(this.filterDataInit);
    this.filterUtil.applySelectedFilter(this, this.getSopraServicesByPage, this.spinnerKey);
  }

  setFilterParamsValues(params: any) {
    this.filterUtil.clearfilterParams(this.filterParamsUrl);
    this.filterUtil.clearfilterParams(this.filterDataInit);
    if (Object.keys(params).length > 0) {
      this.searchValue = params['query'] ? params['query'] : '';
      this.filterParamsUrl = { ...params };
      this.filterDataInit = { ...params };
    }
  }

  getSopraServiceFilter() {
    let params = {
      filter_page: this.filterPage,
    };
    this.filter.getFiltersData(params).subscribe(
      (data) => {
        this.filterData = data;
      },
      (error) => {
        // this.handleBackendError(error);
      }
    );
  }

  getSopraServicesByPage() {
    let params = { ...this.filterParamsUrl };
    params = this.setParams(params);

    this.sopraConfigurationsService.getClassifications(params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data && typeof data === 'object' && 'data' in data) {
        this.sopraServices = data.data || [];
        this.setPaginationConfig(data.meta?.pagination?.count || 0);
      } else {
        this.sopraServices = [];
      }
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: this.filterParamsUrl,
        queryParamsHandling: '',
      });
      this.spinner = false;
      //replace with real data when it's available
    }, (error) => {
      this.spinner = false;
      // this.handleBackendError(error);
    });
  }

  setPaginationConfig(totalItems: number) {
    this.page = this.config.currentPage;
    this.config['totalItems'] = totalItems;
  }

  filterFormValues(event: any) {
    this.spinner = true;
    this.filterParamsUrl = event.filterParamsUrl;
    this.config.currentPage = 1;
    this.config.itemsPerPage = 20;
    this.getSopraServicesByPage();
  }

  setParams(params: any) {
    if (this.searchValue) {
      params['query'] = this.searchValue;
    }
    
    params['is_exsep'] = true;
    params['page'] = this.config.currentPage;
    params['page_size'] = this.config.itemsPerPage;
    return params;
  }

  quickSearch(event: string) {
    this.spinner = true;
    this.searchValue = event;
    this.config.currentPage = 1;
    this.config.itemsPerPage = 20;
    this.getSopraServicesByPage();
  }

  changeToSpecific(event: number) {
    this.pageChanged(event)
  }

  pageChanged(event: number) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => this.spinner = value,
      this.router,
      'page',
      event
    );
    this.config.currentPage = event;
    this.getSopraServicesByPage();
  }

  pageSizeChanged(event: number) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => this.spinner = value,
      this.router,
      'page_size',
      event
    );
    this.config.itemsPerPage = event;
    this.getSopraServicesByPage();
  }

  ngOnDestroy() {
    this.filter.changeSelectedFilter({});
  }

}
